import React from "react";
import Home from "../../container/home";
import Organization from "../../container/organization/organization";
import Practitioner from "../../container/practitioner/practitioner";
import Login from "../../container/login/login";
import Person from "../../container/person/person";
import Docs from '../../container/docs/docs';
import { Routes, Route } from "react-router-dom";
import styles from './site.module.scss';
import ProviderDirectory from "../../container/docs/docs.providerDirectory";
import PatientAccess from "../../container/docs/docs.patientAccess";

const MainContent = () => {

    return (
        <div className={styles.mainContent}>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/Login" element={<Login />} />
                <Route path="/Organization" element={<Organization />} />
                <Route path="/Practitioner" element={<Practitioner />} />
                <Route path="/Person" element={<Person />} />
                <Route path="/docs" element={<Docs />} />
                <Route path="/docs/provider-directory" element={<ProviderDirectory />} />
                <Route path="/docs/patient-access" element={<PatientAccess />} />
            </Routes>
        </div>);
};

export default MainContent;